//#region [IMPORT]

// === THIRD-PARTY ===
import React, {useEffect, useState} from 'react';
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Button,
  Tooltip,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

// === COMPONENTS ===
import Styled from 'components/Styled/Styled';
import {Spacer} from 'components/Spacer';
import { Menu } from 'pages/Menu';

// === HOOKS ===
import { useAnalytics } from 'pages/DocAnalytics/AnalyticsContext/AnalyticsContext';

// === API ===
import { sendMessageData } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function HeaderFileView() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme    = useTheme();
  const navigate = useNavigate();

  const { file_id, file_name, setIsLoading } = useAnalytics();

  //#endregion

  //#region [STYLES]

  const _styles = {
    button_export: {
      height: '40px',
      margin: '0 6px',
    },
    button_evaluate: {
      height: '40px',
      margin: '0 6px',
    },
    button_close: {
      height: '40px',
      margin: '0 6px',
    },
  }

  const tooltip_font_large = {
    slotProps: {
      tooltip: {
        sx: {
          fontSize: '14px', // Set your custom size here
        },
      },
    }
  }

  const BUTTON_EXPORT = {      
    sx       : _styles.button_export,
    variant  : 'contained',
    color    : 'primary',
    onClick  : () => sendMessageData( 'FILE-EXPORT', { id: file_id } ),
    children : 'Export',
    name     : 'da_export_file_results_btn',
  };

  const BUTTON_EVALUATE = {      
    sx       : _styles.button_evaluate,
    variant  : 'contained',
    color    : 'primary',
    onClick  : onClick_Evaluate,
    children : 'Evaluate',
    name     : 'da_evaluate_file_results_btn',
  };

  const BUTTON_CLOSE = {      
    sx       : _styles.button_close,
    variant  : 'contained',
    color    : 'error',
    onClick  : () => { navigate('/analytics/files', { replace: true } ) },
    children : <ArrowBack fontSize='large'/>,
    name     : 'da_close_file_view_btn',
  };

  //#endregion
  
  //#region [EFFECT]

  useEffect( () => {
  }, [] )

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick_Evaluate(event) {
    //-----------------------------------------------------------------
    try {
      sendMessageData( 'FILE-EVALUATE', { id: file_id } )
      setIsLoading( true );
    } catch (error) {
      console.warn(error);
    }
  }

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Menu>
        <Styled styles={[ { display: 'flex' }, {alignItems:'center'}]}>
          <Styled styles={[{width:'fit-content', height: 'fit-content'}, { fontSize: '20px' }, { padding: '4px 8px 4px 8px' } ]}>
            {file_name}
          </Styled>
          <Spacer push_right />
          <Tooltip title="Download json data" { ...tooltip_font_large } >
            <Button { ...BUTTON_EXPORT   } />
          </Tooltip>
          <Tooltip title="Run the rules for this file" { ...tooltip_font_large } >
            <Button { ...BUTTON_EVALUATE } />
          </Tooltip>
          <Tooltip title="Go Back" { ...tooltip_font_large } >
            <Button { ...BUTTON_CLOSE    } />
          </Tooltip>
        </Styled>
      </Menu>
    )
  }

  //#endregion

  return display();
}
